<template>
  <div class="text-base">
    <div class="section-header section-header--xl section-header--dividing mt-3">
      <h1 class="heading">{{ bp('hangTag') }}</h1>
    </div>

    <p class="md:w-1/2" qaid="hangTagSelectFeatureText">{{ bp('selectFeatures') }}</p>

    <div class="section-header section-header--md section-header--dividing mt-4">
      <h3 class="heading">{{ bp('selectLogo') }}</h3>
    </div>

    <fieldset class="form-fieldset">
      <label for="logo-selection-option-1" class="radio">
        <input
          id="logo-selection-option-1"
          v-model="formData.logo"
          v-validate="'required'"
          type="radio"
          name="logo"
          value="logo-trek"
          required
          qaid="hangTagSelectTrekLogo"
        />
        <span class="control-indicator"></span>
        {{ bp('trek') }}
      </label>

      <label for="logo-selection-option-2" class="radio">
        <input
          id="logo-selection-option-2"
          v-model="formData.logo"
          v-validate="'required'"
          type="radio"
          name="logo"
          value="logo-store"
          required
          qaid="hangTagSelectStoreLogo"
        />
        <span class="control-indicator"></span>
        {{ bp('store') }}
      </label>

      <label for="logo-selection-option-3" class="radio">
        <input
          id="logo-selection-option-3"
          v-model="formData.logo"
          v-validate="'required'"
          type="radio"
          name="logo"
          value="logo-exclude"
          required
          qaid="hangTagExcludeLogo"
        />
        <span class="control-indicator"></span>
        {{ bp('excludeLogo') }}
      </label>
    </fieldset>

    <div class="section-header section-header--md section-header--dividing mt-4">
      <h3 class="heading">{{ bp('bikeInformation') }}</h3>
    </div>

    <fieldset class="form-fieldset">
      <label class="checkbox">
        <input
          id="bikeInfo-checkbox-1"
          v-model="formData.showModelYear"
          type="checkbox"
          name="showModelYear"
          value="true"
          qaid="hangTagBikeModelYear"
        />
        <span class="control-indicator"></span>
        {{ bp('includeModelYear') }}
      </label>

      <label class="checkbox">
        <input
          id="bikeInfo-checkbox-2"
          v-model="formData.showPricing"
          type="checkbox"
          name="showPricing"
          value="true"
          qaid="hangTagBikeShowPricing"
        />
        <span class="control-indicator"></span>
        {{ bp('showPricing') }}
      </label>
    </fieldset>

    <fieldset v-show="formData.showPricing" class="form-fieldset">
      <label for="bikeInfo-radio-option-1" class="radio">
        <input
          id="bikeInfo-radio-option-1"
          v-model="formData.showOriginalPrice"
          type="radio"
          name="showOriginalPrice"
          value="true"
          qaid="hangTagBikeShowAdvertised"
        />
        <span class="control-indicator"></span>
        {{ bp('advertised') }}
      </label>

      <label for="bikeInfo-radio-option-2" class="radio">
        <input
          id="bikeInfo-radio-option-2"
          v-model="formData.showOriginalPrice"
          type="radio"
          name="showOriginalPrice"
          value="false"
          :disabled="!(isAppleLabelDealer && hasApplePrice)"
          qaid="hangTagBikeShowOurPrice"
        />
        <span class="control-indicator"></span>
        {{ bp('ourPrice') }}
      </label>
    </fieldset>

    <div class="section-header section-header--md section-header--dividing mt-4">
      <h3 class="heading">{{ bp('otherOptions') }}</h3>
    </div>

    <fieldset class="form-fieldset">
      <label class="checkbox">
        <input
          id="otherOptions-checkbox-1"
          v-model="formData.showMarketingStory"
          type="checkbox"
          name="showMarketingStory"
          value="true"
          qaid="hangTagShowMarketingStory"
        />
        <span class="control-indicator"></span>
        {{ bp('marketingStory') }}
      </label>

      <label class="checkbox">
        <input
          id="otherOptions-checkbox-2"
          v-model="formData.showProductFeatures"
          type="checkbox"
          name="showProductFeatures"
          value="true"
          qaid="hangTagShowProductFeatures"
        />
        <span class="control-indicator"></span>
        {{ bp('productFeatures') }}
      </label>
      <div class="lg:max-w-sm">
        <label for="otherOption.pageFormat" class="form-label">{{ bp('pageFormat') }}</label>
        <div class="select">
          <select
            id="otherOption.pageFormat"
            v-model="formData.pageFormat"
            class="form-control"
            name="pageFormat"
            qaid="handTagPageFormat"
            @change="onPageFormatSelect"
          >
            <option key="0" value="OneSided">
              {{ bp('oneSided') }}
            </option>
            <option key="1" value="TwoSided">
              {{ bp('twoSided') }}
            </option>
          </select>
        </div>
      </div>
    </fieldset>

    <div class="buttons pb-3">
      <trek-link
        ref="downloadButton"
        button
        primary
        icon="get_app"
        download="file.pdf"
        :href="requestUrl"
        qaid="hangTagDownload"
        @click="onSubmit"
      >
        <span v-html="bp('downloadTag')"></span>
      </trek-link>
      <trek-button secondary qaid="hangTagCancel" @click="close">
        <span v-html="bp('cancel')"></span>
      </trek-button>
    </div>

    <input
      id="productCode"
      type="hidden"
      name="productCode"
      value="${hangTagForm.productCode}"
      qaid="hangTagHiddenProductCode"
    />

    <input id="hangTagsPdfUrl" type="hidden" value="${hangTagPdfUrl}" qaid="hangTagHiddenPdfUrl" />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';

export default {
  components: {TrekButton, TrekLink},
  props: {
    productCode: {
      type: String,
      required: true,
    },
    hangTagPdfUrl: {
      type: String,
      required: true,
    },
    returnUrl: {
      type: String,
      required: true,
    },
    hasApplePrice: {
      type: Boolean,
      required: true,
    },
    isAppleLabelDealer: {
      type: Boolean,
      required: true,
    },
    isShipment: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      includeImage: false,
      formData: {
        logo: 'logo-store',
        showModelYear: true,
        showPricing: true,
        showOriginalPrice: true,
        showMarketingStory: false,
        showProductFeatures: true,
        paperSize: 'Letter',
        pageFormat: 'OneSided',
        pdfName: '',
        pdfView: true,
        productCode: this.productCode,
        tidyHTML: true,
        suffixTimestamp: false,
        isShipment: this.isShipment,
      },
    };
  },

  computed: {
    ...mapState('backend', ['encodedContextPath']),

    // Split the bound form data values into a query string to be sent with the request for the PDF
    query() {
      const esc = encodeURIComponent;
      return Object.keys(this.formData)
        .map((k) => esc(k) + '=' + esc(this.formData[k]))
        .join('&');
    },

    // The URL that will get used as the target for getting the PDF
    requestUrl() {
      return `${this.hangTagPdfUrl}${this.formData.productCode}/pdf?${this.query}`;
    },

    pdfName() {
      return `Hang_Tag_${this.productCode}`;
    },
  },

  mounted() {
    this.formData.pdfName = this.pdfName;
  },

  methods: {
    // In modern browsers, download the PDF by programatically clicking the HTML link with the
    // download attribute. For browsers that don't support it, just open a new window before
    // redirecting
    downloadPDF(e) {
      if (typeof this.$refs.downloadButton.download != 'undefined') {
        return this.close();
      } else {
        e.preventDefault();
        window.open(this.requestUrl, '_blank');
      }
      return this.close();
    },

    onSubmit(e) {
      // Validate using v-validate. If there are errors, scroll the browser to top-most error
      // on the page
      this.$validator.validate().then((valid) => {
        if (!valid) {
          const firstErrorFieldName = Object.keys(this.$validator.errors.collect())[0];
          const firstErrorFieldEl = document.querySelector(`[name="${firstErrorFieldName}"]`);
          this.$scrollTo(firstErrorFieldEl);
        } else {
          return this.downloadPDF(e);
        }
      });
    },

    close() {
      if (this.isShipment === 'true') {
        window.close();
      } else {
        this.redirectToPdp();
      }
    },

    redirectToPdp() {
      return location.replace(this.returnUrl);
    },
    onPageFormatSelect(e) {
      this.formData.pageFormat = e.target.value;
    },
  },
};
</script>
